var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircleEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7023 8.39449L10.9183 13.3635L9.2853 11.2775C8.9453 10.8415 8.3153 10.7655 7.8813 11.1065C7.4463 11.4465 7.3693 12.0755 7.7103 12.5095L10.1413 15.6165C10.3313 15.8585 10.6213 15.9995 10.9293 15.9995H10.9363C11.2453 15.9985 11.5373 15.8525 11.7243 15.6055L16.2933 9.60549C16.6283 9.16549 16.5433 8.53949 16.1033 8.20449C15.6623 7.86949 15.0363 7.95549 14.7023 8.39449ZM11.9948 20C7.58379 20 3.99479 16.411 3.99479 12C3.99479 7.58902 7.58379 4.00002 11.9948 4.00002C16.4058 4.00002 19.9948 7.58902 19.9948 12C19.9948 16.411 16.4058 20 11.9948 20ZM11.9961 2C6.47309 2 1.99609 6.478 1.99609 12C1.99609 17.522 6.47309 22 11.9961 22C17.5191 22 21.9961 17.522 21.9961 12C21.9961 6.478 17.5191 2 11.9961 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleEmpty);
export default __webpack_public_path__ + "static/media/CheckmarkCircleEmpty.d519870501e163891136d59579cfa291.svg";
export { ForwardRef as ReactComponent };